// Exports a Button component that accepts children as props. This allows the Button component to display any content passed to it.
export const Button = ({children}) => {
  // Returns a button element with styling classes applied for width, text size, text color, background gradient, rounding of corners, padding, margin, and font weight.
  return (
    // The className attribute applies Tailwind CSS classes for styling the button.
    // "w-64" sets the width, "text-xl" sets the text size, "text-white" sets the text color,
    // "bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700" creates a background color gradient,
    // "rounded-lg" rounds the corners, "px-5 py-2.5" sets the padding, "mr-2 mb-2" sets the right margin and bottom margin,
    // "font-medium" sets the font weight.
    // The children prop is used to insert any child elements or text inside the button, making this component reusable.
    <button className="w-64 text-xl text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-lg px-5 py-2.5 mr-2 mb-2 font-medium">{children}</button>
  )
}
